import Vue from 'vue';
import { waitUntil } from '@/util/promise-util';
export default {
	async permissionGuard(to, from, next) {
		await waitUntil(async () => {
			await Vue.auth.refresh();
			await Vue.auth.fetch();
			return await Vue.auth.check();
		});
		if (
			to.meta.requiredRoles.some(
				(role: string | number) => Vue.auth.user() && Vue.auth.user()[role] === true,
			)
		) {
			next();
		} else {
			next({
				name: from.name ?? 'home',
				params: {
					errorMsg: "Sorry you don't have the right access to reach the route requested",
					...from.params,
				},
				query: { redirectFrom: to.fullPath },
			});
		}
	},
};
